module.exports = __webpack_public_path__ + "static/media/ssl_icon_new.915edd0b.svg";